module.exports = __webpack_public_path__ + "static/img/充装.df40bd5b.png";